// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1440px) {
  .Loader_loadingScreen__P2c\\+h {
    min-height: calc(100vh - 125px) !important;
  }
}
.Loader_loadingScreen__P2c\\+h {
  position: relative;
  min-height: calc(100vh - 145px);
  height: 100%;
  width: 100%;
  opacity: 0;
  animation: Loader_fadeScreen__XiLlb 0.4s ease-in forwards;
  background: #fff;
}
.Loader_loadingScreen__inner__48fwj {
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.Loader_loadingScreen__inner__48fwj .Loader_ball__LuIbk {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: #1b5299;
  margin: 0 6px 0 0;
  animation: Loader_oscillate__-6-Jw 0.7s ease-in forwards infinite;
}
.Loader_loadingScreen__inner__48fwj .Loader_one__YKFml {
  animation-delay: 0.5s;
}
.Loader_loadingScreen__inner__48fwj .Loader_two__waoCo {
  animation-delay: 1s;
}
.Loader_loadingScreen__inner__48fwj .Loader_three__4aHw4 {
  animation-delay: 2s;
}
@keyframes Loader_oscillate__-6-Jw {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(20px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes Loader_fadeScreen__XiLlb {
  0% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    opacity: 1;
  }
}

body[data-theme=dark] .Loader_loadingScreen__P2c\\+h {
  background: #111 !important;
}
body[data-theme=dark] .Loader_loadingScreen__inner__48fwj .Loader_ball__LuIbk {
  background: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/apps/core/common/Loader/Loader.module.scss"],"names":[],"mappings":"AAAA;EACE;IACE,0CAAA;EACF;AACF;AAEA;EACE,kBAAA;EACA,+BAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,yDAAA;EACA,gBAAA;AAAF;AAEE;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAAJ;AAEI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iEAAA;AAAN;AAGI;EACE,qBAAA;AADN;AAGI;EACE,mBAAA;AADN;AAGI;EACE,mBAAA;AADN;AAII;EACE;IACE,wBAAA;EAFN;EAII;IACE,2BAAA;EAFN;EAII;IACE,wBAAA;EAFN;AACF;AAME;EACE;IACE,YAAA;EAJJ;EAME;IACE,YAAA;EAJJ;EAME;IACE,UAAA;EAJJ;AACF;;AASE;EACE,2BAAA;AANJ;AAQM;EACE,2BAAA;AANR","sourcesContent":["@media (max-width: 1440px){\n  .loadingScreen {\n    min-height: calc(100vh - 125px) !important;\n  }\n}\n\n.loadingScreen {\n  position: relative;\n  min-height: calc(100vh - 145px);\n  height: 100%;\n  width: 100%;\n  opacity: 0;\n  animation: fadeScreen 0.4s ease-in forwards;\n  background: #fff;\n\n  &__inner {\n    display: flex;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n\n    .ball {\n      height: 20px;\n      width: 20px;\n      border-radius: 50%;\n      background: #1b5299;\n      margin: 0 6px 0 0;\n      animation: oscillate 0.7s ease-in forwards infinite;\n    }\n\n    .one {\n      animation-delay: 0.5s;\n    }\n    .two {\n      animation-delay: 1s;\n    }\n    .three {\n      animation-delay: 2s;\n    }\n\n    @keyframes oscillate {\n      0% {\n        transform: translateY(0);\n      }\n      50% {\n        transform: translateY(20px);\n      }\n      100% {\n        transform: translateY(0);\n      }\n    }\n  }\n\n  @keyframes fadeScreen {\n    0% {\n      opacity: 0.4;\n    }\n    50% {\n      opacity: 0.8;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n}\n\nbody[data-theme=\"dark\"]{\n  .loadingScreen{\n    background: #111 !important;\n    &__inner {\n      .ball {\n        background: #fff !important;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingScreen": `Loader_loadingScreen__P2c+h`,
	"fadeScreen": `Loader_fadeScreen__XiLlb`,
	"loadingScreen__inner": `Loader_loadingScreen__inner__48fwj`,
	"ball": `Loader_ball__LuIbk`,
	"oscillate": `Loader_oscillate__-6-Jw`,
	"one": `Loader_one__YKFml`,
	"two": `Loader_two__waoCo`,
	"three": `Loader_three__4aHw4`
};
export default ___CSS_LOADER_EXPORT___;
